import React from "react";

import Modalresult from "./Modalresult";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import { Inbox } from "@components/Common/SvgIcons/Inbox";

type PatternType = {
    rowData: any;
    oneShop: boolean;
};

export function OpenCapot({ rowData, oneShop }: PatternType) {
    const [overview, setOverview] = React.useState<boolean>(false);
    // const socket = io("https://demo-setting-api.aureskonnect.com/");
    const [isAssociateModalOpened, setIsAssociateModalOpened] = React.useState<
        boolean
    >(false);
    // async function handleButtonClickEvent() {
    //     socket.emit("sendEvent", {
    //         type: "send",
    //         userId: franchiseID,
    //         url:
    //             "http://192.168.1.10:5001/api/v1/RestartMachine?IpCash=192.168.1.24",
    //     });
    // }

    return (
        <React.Fragment>
            <div
                onClick={() => {
                    // handleButtonClickEvent();
                    setIsAssociateModalOpened(!isAssociateModalOpened);
                }}
                className="page-card-carte col-lg-4 col-xl-4 col-md-6 col-sm-12 col-xs-12 my-2"
                style={{
                    cursor: "pointer",
                }}
                onMouseEnter={() => {
                    setOverview(true);
                }}
                onMouseLeave={() => {
                    setOverview(false);
                }}
            >
                <div
                    className="card float-right page-content_Carte"
                    style={{
                        padding: "1em",
                        borderRadius: "12px",
                        boxShadow: "0px 5px 10px #00000042",
                        backgroundColor: "auto",
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 0,
                        height: "170px",
                    }}
                >
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-xl-4 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-center">
                            <div
                                style={{
                                    backgroundColor: overview
                                        ? "#FFFFFF"
                                        : "#5b5b5b",

                                    borderRadius: "50%",

                                    padding: "20px",
                                }}
                            >
                                {overview ? (
                                    <Inbox
                                        className="d-block w-100"
                                        fill="#292929"
                                        stopColor="#FFFFFF"
                                    />
                                ) : (
                                    <Inbox
                                        fill="#FFFFFF"
                                        stopColor="#5B5B5B"
                                        className="d-block w-100"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="col-lg-12 col-xl-8 col-md-12 col-sm-12 col-xs-12">
                            <div className="card-block">
                                <div className="d-flex flex-column pl-1">
                                    <div
                                        className="d-flex justify-content-between card-title"
                                        style={{
                                            color: "rgb(41, 41, 41)",
                                            letterSpacing: "1.4px",
                                        }}
                                    >
                                        <div className="text-uppercase">
                                            Ouvrir capôt
                                        </div>
                                    </div>

                                    <p
                                        style={{
                                            color: "rgb(33, 39, 57)",
                                        }}
                                        className="card-text"
                                    >
                                        Description à ajouter.Description à
                                        ajouter.Description à
                                        ajouter.Description à ajouter.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modalresult
                setIsDeviceAssociateModalOpened={setIsAssociateModalOpened}
                isDeviceAssociateModalOpened={isAssociateModalOpened}
                rowData={rowData}
            />
        </React.Fragment>
    );
}
